export default __webpack_public_path__ + "static/media/in.dbb74f21.svg";